export default __webpack_public_path__ + "media/flags/fr-a2504ba6.svg";